import { Link } from '@/components'

export const AlreadyMemberNotice = () => (
  <p role="alert" className="text-sm text-red-600">
    This email already has a CounselPro account.{' '}
    <Link to="/" theme="brand" className="font-medium">
      Sign in
    </Link>
  </p>
)
